import React from 'react';
import { Card, Modal, Tag, message } from 'antd';
import { LoadingOutlined, ProfileOutlined } from '@ant-design/icons';
import IntlMessages from '../../../../../util/IntlMessages';
import { useIntl } from 'react-intl';
import { useMutation } from '@apollo/client';
import { gql } from '@apollo/client';
import { PrintButton } from '../../../../../components/FileButton';
import { defaultCatchException, defaultMutationHandler } from '../../../../../apollo/callbacks';


const GQL_GENERATE_ASI_CARD = gql`
    mutation generateASICard($id: String!){
        generateASICard(id: $id)
    }
`

const GQL_PRINT_ASI_CARD = gql`
    query printASICard($id: String!){
        printASICard(id: $id) {
            filename
            content
        }
    }
`

const AsiCard = ({ player, subEvent }) => {

    const intl = useIntl();

    const [generateASICard, { loading }] = useMutation(GQL_GENERATE_ASI_CARD);

    return (
        <Card
            title={
                <span>
                    Tesseramento ASI
                </span>
            }
            className="gx-card"
            actions={[
                player.asi_athlete_card_code ? (
                    <PrintButton
                        key="3"
                        query={{ query: GQL_PRINT_ASI_CARD, variables: { id: player.id } }}
                        context="printASICard"
                        title="Stampa Tessera ASI"
                        filename="tessera-asi.pdf"
                    />
                ) : (
                    <a onClick={() => {

                        if (!subEvent.asi_card_type) {
                            message.error(intl.formatMessage({ id: 'common.asi_card_type_not_found' }));
                            return;
                        }

                        Modal.confirm({
                            title: intl.formatMessage({ id: 'common.confirm' }),
                            content: intl.formatMessage({ id: 'common.generate_asi_confirmation' }),
                            okText: loading ? <LoadingOutlined /> : intl.formatMessage({ id: 'common.yes' }),
                            onOk() {
                                generateASICard({
                                    variables: {
                                        id: player.id
                                    }
                                }).then(
                                    defaultMutationHandler({
                                        successCallback: () => {
                                            message.success(intl.formatMessage({ id: 'common.operation_successful' }));
                                        },
                                        errorCallback: (e) => {
                                            if (
                                                e.length > 0 &&
                                                e[0]?.message &&
                                                intl.messages[e[0].message]
                                            ) {
                                                message.error(intl.formatMessage({ id: e[0].message }));
                                            } else {

                                                defaultCatchException(e, intl);
                                            }
                                        }
                                    })
                                )
                                    .catch((e) => defaultCatchException(e, intl));
                            }
                        })
                    }}
                        key="generate_asi"
                        type="primary"
                    >
                        <ProfileOutlined className="gx-pr-1" />
                        <IntlMessages id="common.generate" />
                    </a>
                )
            ].filter(Boolean)}
        >
            <IntlMessages id="common.type" /> <Tag>{subEvent.asi_card_type || intl.formatMessage({ id: 'common.not_available' })}</Tag>
        </Card>
    )
}

export default AsiCard;